// tslint:disable:curly
import { ProjectService } from './project.service';
import { DbRecord } from './db-record';
import { Tag } from './tag';
import { Criterion } from './criterion';
import { Note } from './note';

export class Project {
  private _title: string;
  private _shortcut: string;
  isNew: boolean;
  isInitialized = false;
  // dbRecordId  -> userEmail -> ratingsSet
  ratersEmails = { abstract: [], fulltext: [] };
  abstractRatings = new Map<string, Map<string, [string, Set<string>]>>();
  fulltextRatings = new Map<string, Map<string, [string, Set<string>]>>();
  users = new Set<string>();
  isOwner = false;
  tagsMap = new Map<string, Tag>();
  criterionsMap = new Map<string, Criterion>();
  notesMap = new Map<string, Map<string, Note>>();
  linkCodes: Object;



  abstractRejectIds: string[];
  abstractAcceptIds: string[];
  rtags = [];
  rTagsTitlesMap = new Map<string, string>();

  private _highlightsRaw;
  private _highlights;
  private _hasHighlights = true;


  constructor(
    private projects: ProjectService,
    public id: string,
    title: string,
    isOwner?: boolean
  ) {
    if (isOwner) {
      this.isOwner = true;
    }
    this._highlightsRaw = this.projects.data.highlights;
    this.title = title;
    this.isNew = title === '';
    projects.projectMap.set(this.id, this);
  }

  private _ratingMap(ratingType: string) {
    switch (ratingType) {
      case 'abstract': return this.abstractRatings;
      case 'fulltext': return this.fulltextRatings;
    }
  }

  get recordIds() {
    return this.projects.recordIds(this);
  }

  get fulltextRatingsBackup() {
    console.log('FULLTEXT RATINGS BACKUP IS NOT IMPLEMENTED');
    return [];
  }

  get abstractRatingsBackup() {
    let ls = [];
    let arm = this.abstractRatings;

    arm.forEach((mp, recordId) => {
      let raters = [];
      let dct = { recordId: recordId, raters: raters };
      ls.push(dct);
      mp.forEach((tpl, email) =>
        raters.push([email, tpl[0], Array.from(tpl[1])]));
    });
    // console.log(JSON.stringify(ls).slice(0, 2000))
    return ls;
  }

  get ratingTagsBackup() {
    let ls = [];
    let tm = this.projects.getProjectRatingTags(this);
    tm.forEach((sss, k) => {
      ls.push({ recordId: k, tags: Array.from(sss) });
      /*m1.forEach((note, k2) => {
        console.log(k2, note)
        ls.push({creator:note.creator,
        date:note.date, parent:note.parentId, text:note.text})
      })*/
    });
    console.log(JSON.stringify(ls).slice(0, 2000));
    return ls;
  }


  get notesBackup() {
    let ls = [];
    let nm = this.notesMap;
    nm.forEach((m1, k1) => {
      m1.forEach((note, k2) => {
        ls.push({
          creator: note.creator,
          date: note.date, parent: note.parentId, text: note.text
        });
      });
    });
    // console.log(JSON.stringify(ls).slice(0,2000))
    return ls;
  }

  highlightHits(txt) {
    if (!txt)
      return txt;
    if (!this._hasHighlights || !this.shortcut)
      return txt;
    if (!this._highlights) {
      let ls = this._highlightsRaw[this.shortcut];
      if (!ls) {
        this._hasHighlights = false;
        return txt;
      }
      this._highlights = ls.map(x => new RegExp(x, 'ig'));
    }

    this._highlights.forEach(x => txt = txt.replace(x,
      '<span class="criterionHit">$&</span>'));

    return txt;
  }

  dbRecordHasOwnerNote(dbRecord: DbRecord) {
    let nm = this.notesMap.get(dbRecord.id);
    if (!nm)
      return false;
    return nm.has(this.projects.email);
  }

  dbRecordNotes(dbRecord: DbRecord) {
    let nm = this.notesMap.get(dbRecord.id);
    if (!nm)
      return [];
    let ls = [];
    nm.forEach(n => ls.push(n));
    ls.sort((a, b) => {
      if (a.creator === this.projects.email)
        return -1;
      if (b.creator === this.projects.email)
        return 1;
      return a.creator < b.creator ? -1 : 1;
    });
    return ls;
  }

  getNote(parentId: string) {
    return this.notesMap.get(parentId);
  }

  switchUser(email) {
    this.projects.switchUser(this, email);
  }

  initSupportData(obj) {
    obj['criterions'].forEach(x => this.projects.createCriterion(this, x));
    obj['tags'].forEach(x => this.projects.createTag(this, x));
  }

  initNotes(ls: string[]) {
    this.users = new Set<string>(ls);
  }

  initCollaborators(ls: string[]) {
    this.users = new Set<string>(ls);
  }

  initRatings(ls: Object[]) {
    this.abstractRatings.clear();
    this.fulltextRatings.clear();

    ls.forEach((obj) => {
      const m = this._ratingMap(obj['type']);
      const email = obj['email'];
      let emailInRaters = false;
      Object.keys(obj).forEach((k) => {
        if (k === 'type' || k === 'email') {
          return;
        }
        if (!emailInRaters) {
          this.ratersEmails[obj['type']].push(email);
          emailInRaters = true;
        }
        let mm = m.get(k);
        if (!mm) {
          mm = new Map<string, [string, Set<string>]>();
          m.set(k, mm);
        }
        const tpl = obj[k];
        mm.set(email, [tpl[0], new Set<string>(tpl[1])]);
      });
    });
  }

  currentRatingState(dbRecord: DbRecord,
    ratingType: string,
    ratingId: string
  ) {
    let mm = this._ratingMap(ratingType).get(dbRecord.id);
    if (!mm)
      return ratingId === 'notRated';
    let tpl = mm.get(this.projects.email);
    if (!tpl)
      return ratingId === 'notRated';
    return tpl[1].has(ratingId);
  }

  isAbstractRated(dbRecord: DbRecord) {
    let mm = this._ratingMap('abstract').get(dbRecord.id);
    if (!mm)
      return false;
    let flag = false;
    mm.forEach(tpl => {
      if (tpl[0] === 'accepted')
        flag = true;
    });
    return flag;
  }

  ratingSummary(dbRecord: DbRecord,
    ratingType: string) {
    return this._ratingMap(ratingType).get(dbRecord.id);
  }

  ratingChange(dbRecord: DbRecord,
    ratingType: string,
    state: string,
    ratingId: string,
    postponeSave?: boolean
  ) {
    let m = this._ratingMap(ratingType);
    let mm = m.get(dbRecord.id);
    if (!mm) {
      mm = new Map<string, [string, Set<string>]>();
      m.set(dbRecord.id, mm);
    }

    let tpl = mm.get(this.projects.email);
    if (!tpl || tpl[0] !== state) {
      tpl = [state, new Set<string>()];
      mm.set(this.projects.email, tpl);
    }

    if (ratingId === 'notRated')
      mm.delete(this.projects.email);
    else {
      if (!tpl[1].delete(ratingId))
        tpl[1].add(ratingId);
      if (!tpl[1].size)
        mm.delete(this.projects.email);
    }

    if (!postponeSave) {
      this.projects.saveRating(this,
        dbRecord,
        ratingType,
        mm.get(this.projects.email));
    }
  }

  adminRatingDelete(dbRecord: DbRecord,
    ratingType: string,
    email: string) {
    let obs = this.projects.adminRatingDelete(this,
      dbRecord,
      ratingType,
      email);

    obs.subscribe((resp) => {
      if (!resp['isSuccess'])
        return alert('ADMIn DELETE failure');
      let m = ratingType === 'abstract' ? this.abstractRatings : this.fulltextRatings;
      m.get(dbRecord.id).delete(email);
    });
    return obs;
  }

  get criterionsList() {
    if (!this.isInitialized)
      return [];
    let ls = Array.from(this.criterionsMap.values());
    return ls.sort((a, b) => a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1);
  }

  get tagsList() {
    if (!this.isInitialized)
      return [];
    let ls = Array.from(this.tagsMap.values());
    return ls.sort((a, b) => a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1);
  }


  set title(txt) {
    this._title = (txt && txt.trim()) || '???';
  }

  get title() {
    return this._title;
  }

  set shortcut(txt) {
    this._shortcut = txt.trim();
  }

  get shortcut() {
    return this._shortcut;
  }

  initProject() {
    if (this.isInitialized)
      return;
    this.projects.initProject(this);
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/project.ts